import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from 'app/client-core/services/user.service';

@Pipe({
  name: 'haveClaim'
})
export class HaveClaimPipe implements PipeTransform {
  constructor(
    private userService: UserService
  ) {}
  transform(resource: string, operation: string): boolean {
    const claims = this.userService.getLocalClaims();
    const claim = claims.find(c => c.operation == operation && c.resource == resource);
    if (claim) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/have-claim.pipe.ts